// Maps frontend route trial IDs to backend trial IDs where they differ.
// Used in API calls and feature-flag lookups so URL-facing IDs can differ
// from the IDs used in the backend database.
export const TRIAL_ID_MAP: Record<string, string> = {
  "DARATU-ALZ": "DEMO_TRIAL",
};

export function toBackendTrialId(frontendId: string): string {
  return TRIAL_ID_MAP[frontendId] ?? frontendId;
}
